import styled from 'styled-components';
export var CleanClassBadge = styled.span.withConfig({
  displayName: "partials__CleanClassBadge",
  componentId: "sc-tog8r9-0"
})(["display:inline-flex;align-items:center;height:20px;padding:4px 6px;border-radius:4px;margin-left:9px;background-color:", ";font-size:10px;font-weight:400;line-height:16px;white-space:nowrap;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.accent3M;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.terciaryD;
});